<template>
    <div class='forest text-center'>
        <h6 class="text-center">{{'lucky_symbols' | lang}}</h6>
        <div class="lucky-symbols w-100 d-flex align-items-center justify-content-center">
            <div v-for="(symbol, itemIndex) in luckySymbols" :key="itemIndex" :class="{'symbol d-flex align-items-center justify-content-center':true, 'lucky' : luckySymbolsArray.includes(symbol)}"> 
                <img class="img-fluid" :src="`/fg/v2/games/forest/img/history/symbol_${symbol}.png`">
            </div>
        </div>
        <div v-if="luckyYourSymbols.length || luckyBonusSymbol" class="">
            <div v-if="luckyYourSymbols.length">
                <h6 class="text-center pt-3">{{'your_symbols' | lang}}</h6>
                <div class="your-symbols w-100 d-flex align-items-center justify-content-center justify-content-lg-start flex-wrap">
                    <div v-for="(item, itemIndex) in luckyYourSymbols" :key="itemIndex" class="symbol"> 
                        <div v-if="item.symbol" class="w-100">
                            <img class="img-fluid" :src="`/fg/v2/games/forest/img/history/symbol_${item.symbol_after ? item.symbol_after : item.symbol}.png`">
                            <span class="amount" v-if="item.amount">
                                {{item.amount}}
                            </span>
                        </div>
                        <div v-else>
                            <img class="img-fluid" :src="`/fg/v2/games/forest/img/history/symbol_${item}.png`">
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="luckyBonusSymbol">
                <h6 class="text-center pt-3" >{{'bonus' | lang}}</h6>
                <div class="bonus-symbols w-100 d-flex align-items-center justify-content-center">
                    <span v-if = "luckyBonusSymbol.amount" class="amount">{{luckyBonusSymbol.amount}}</span>
                    <img v-else class="img-fluid" :src="`/fg/v2/games/forest/img/Wheel_${luckyBonusSymbol.gem}_Gems_Prize.png`">
                </div>
            </div>
        </div>
        <div v-else class = 'no-winnings d-flex align-items-center justify-content-center'>
            <h6>{{'noWinning' | lang}}</h6>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['ticket', 'gameName'],
        data() {
            return {
                luckySymbolsArray:[]
            }
        },
        computed: {
            luckySymbols() {
                let luckies = [];
                this.luckySymbolsArray = [];

                for (const [key, symbol] of Object.entries(this.ticket.scenario.lucky_symbols)) {
                    luckies.push(symbol);
                }

                return luckies;
            },
            luckyYourSymbols() {
                let luckies = [];
                this.luckySymbolsArray = [];

                for (const [key, symbol] of Object.entries(this.ticket.scenario.your_symbols)) {
                    if (symbol === 'bonus_symbol' || symbol === 'gem_symbol') {
                        this.luckySymbolsArray.push(symbol);
                        luckies.push(symbol);
                    } else if (symbol.win || symbol.win_after) {
                        luckies.push(symbol);
                        this.luckySymbolsArray.push(symbol.symbol);
                    }
                }

                return luckies;
            },
            luckyBonusSymbol() {
                if (this.ticket.scenario.bonus) {
                    for (const [key, item] of Object.entries(this.ticket.scenario.bonus)) {
                        if (item.win) {
                            return item;
                        }
                    }
                }
            }
        }
    }
</script>

<style>
    .forest .symbol {
        width: 33.33%;
        padding: 5px;
        max-width: 80px;
        position: relative;
    }

    .forest .lucky-symbols .symbol {
        opacity: 0.5;
    }

    .forest .lucky-symbols .symbol.lucky {
        opacity: 1;
    }

    .forest .your-symbols .amount {
        position: absolute;
        bottom: -5px;
        text-align: center;
        font-family: carterone;
        width: 100%;
        font-size: 22px;
        margin-left: auto;
        margin-right: auto;
        color: #fff;
        -webkit-text-stroke: 1.2px #F383CA;
        white-space: nowrap;
        transform: translateX(-50%);
        left: 50%;
        text-shadow: 6px 6px 30px #F383CA;
    }

    .forest .bonus-symbols .amount {
        text-align: center;
        font-family: carterone;
        font-size: 50px;
        margin-left: auto;
        margin-right: auto;
        color: #FFFFFF;
        -webkit-text-stroke: 0.1rem #50417A;
        white-space: nowrap;
        text-shadow: 6px 0px 10px #47479F;
        margin-top: -10px;
    }

    .forest .no-winnings {
        height: 100px;
        width: 100%;
        border: 1px white dotted;
        border-radius: 10px;
        margin-top: 15px;
    }

    .forest .bonus-symbols img {
        width: 100px;
    }
</style>